module.exports = __webpack_public_path__ + "img/galeria-especie-mar1.3a6d3bf4.jpg";